<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1021 -749)">
			<path
				d="M29.585,8.406a15,15,0,1,0,3.9,14.344h-3.9a11.245,11.245,0,1,1-10.594-15A11.09,11.09,0,0,1,26.9,11.087l-6.037,6.038H33.991V4Z"
				transform="translate(1024.509 752.5)" />
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1021 749)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'b-icon-refresh',
		components: {},
		computed: {},
		props: {},
	};
</script>

<style scoped lang="scss">
	path.a {
		fill: none;
	}
</style>

<docs>
	IconRefresh

	```js
	<b-icon-refresh />
	```
</docs>